import type { FaireProductEntity } from "../../entity_types/product";

export const p_7xagxx6gys: FaireProductEntity = {
  token: "p_7xagxx6gys",
  type: "product",
  name: "The World's Best Chocolate | Unique Chocolate Gift Box",
  brandToken: "b_215xw4p1o0",
  brandName: "Universal Yums",
  imageUrl:
    "https://cdn.faire.com/fastly/503d401d5ea6d40b4e0eec8ae8176f12d05aa205f5352b9b92435fd75fae3b55.png",
  galleryImageUrls: [],
  priceDollars: 17.32,
  description:
    "We’ve found the top contenders for the World’s Best Chocolate, now you decide which is the best of the best! All eight chocolates express the culinary leanings of the countries they originate from, ranging from a quirky chocolate snack from Korea to melty, rich hazelnut “gianduja” from Italy.",
  tags: [],
  msrpDollars: 34.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:51.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
